import styled from 'styled-components'
import Icon from '../Icon/Icon'
import Button from '../Button/Button'

export const Label = styled.label`
  width: 100%;
  font-size: inherit;
  position: relative;
  display: block;
  margin-bottom: 0;
  hyphens: auto;
  font-weight: 400;
  line-height: 1.44;
`

export const ErrorMessage = styled.div`
  position: absolute;
  width: calc(100% + 2px);
  padding: 15px;
  background-color: ${ (props) => props.theme.colors['fehler-rot'] };
  color: ${ (props) => props.theme.colors.weiss };
  top: ${ (props) => props.topStyle };
  left: -1px;

  @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
    width: max-content;
  }

  &:after {
    position: absolute;
    bottom: -10px;
    left: 14px;
    display: inline-block;
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${ (props) => props.theme.colors['fehler-rot'] };
  }
`

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  box-shadow: none;
  border: 1px solid #c1c1be;
  border-color: ${ (props) =>
    props.focus ? (props) => props.theme.colors['aok-gruen'] : '#c1c1be' };
  background-color: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  :hover {
    border-color: ${ (props) =>
      props.hasError
        ? props.theme.colors['fehler-rot']
        : props.theme.colors['aok-gruen'] };
  }

  ::placeholder {
    color: ${ (props) => props.theme.colors.grau2 };
  }
`

export const DeleteButton = styled(Button).attrs(() => ({
  className: 'btn-default',
}))`
  background: transparent !important;
  min-width: auto !important;
  display: block;

  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    width: auto;
  }

  :before {
    font-size: 7px;
    border-radius: 50%;
    padding: 5px;
    background-color: ${ (props) => props.theme.colors['icon-grau3'] };
  }

  :hover,
  :focus {
    border-color: transparent;
    box-shadow: none;
    background-color: transparent;
  }

  :hover::before,
  :focus::before {
    background-color: ${ (props) => props.theme.colors['icon-grau1'] };
  }
`

export const LoadingIcon = styled(Icon)`
  animation: icon-spin 1s infinite linear;
  margin-right: 12px;
`

export const Input = styled.input`
  width: 100%;
  min-width: 0px;
  border: 0;
  display: block;
  background: none;
  box-sizing: content-box;
  line-height: 1.5;
  font-weight: 200;
  font-size: inherit;
  padding: 0 12px;
  text-overflow: ellipsis;
  flex: 1 1 100%;
  color: ${ (props) => props.theme.colors.standardSchwarz };

  :focus {
    outline: 0;
  }

  ::-ms-clear {
    display: none;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: 0 16px;
  }
`

export const StartAdornment = styled.div`
  display: block;
  color: ${ (props) => props.theme.colors['icon-grau2'] };
  font-size: 21px;
  flex-shrink: 0;
  padding-left: 12px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding-left: 16px;
  }

  span {
    display: flex;
  }
`

export const EndAdornment = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;

  & > button {
    background: transparent !important;
    min-width: auto;

    :before {
      font-size: 20px;
      color: ${ (props) => props.theme.colors['icon-grau2'] };
    }

    :hover,
    :focus {
      outline: 0;
      border-color: transparent;
      background: transparent;

      :before {
        color: ${ (props) => props.theme.colors['icon-grau1'] };
      }
    }
  }
`
